const routes = require('next-routes');

module.exports = routes()
    .add('index', '/', 'Home')
    .add('advertisers', '/lojas', 'Advertisers')
    .add('categories', '/categorias', 'Categories')
    .add('deals_page', '/cupom-de-desconto-:slug', 'DealsPage')
    .add('contact', '/contato', 'Contact')
    .add('faq', '/faq.html', 'Faq')
    .add('privacy_policy', '/privacidade.html', 'PrivacyPolicy')
    .add('about', '/sobre.html', 'About')
    .add('terms_of_use', '/termos-de-uso.html', 'TermsOfUse');